"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _rsManagement = require("@/api/rsManagement");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'RefundDialog',
  data: function data() {
    return {
      visible: false,
      loading: false,
      submitting: false,
      refundType: 1,
      orderRow: null,
      orderNo: '',
      orderAmount: 0,
      goodsList: []
    };
  },
  methods: {
    open: function open(row) {
      this.orderRow = row || {};
      this.orderNo = row.orderNo || '';
      this.orderAmount = row.totalAmount || 0;
      this.refundType = 1;
      this.goodsList = [];
      this.visible = true;
      this.loadDetail();
    },
    loadDetail: function () {
      var _loadDetail = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this = this;
        var res, detail, items, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (this.orderNo) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              this.loading = true;
              _context.p = 2;
              _context.n = 3;
              return (0, _rsManagement.getTakeoutRefundDetail)(this.orderNo);
            case 3:
              res = _context.v;
              detail = res || {};
              this.orderAmount = this.pickAmount(detail);
              items = detail.orderItems || detail.products || [];
              this.goodsList = items.map(function (item) {
                return _this.normalizeItem(item);
              });
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
              this.$message.error(_t.message || '获取订单详情失败');
            case 5:
              _context.p = 5;
              this.loading = false;
              return _context.f(5);
            case 6:
              return _context.a(2);
          }
        }, _callee, this, [[2, 4, 5, 6]]);
      }));
      function loadDetail() {
        return _loadDetail.apply(this, arguments);
      }
      return loadDetail;
    }(),
    pickAmount: function pickAmount(detail) {
      if (detail.orderTotalAmount != null && detail.orderTotalAmount !== '') return detail.orderTotalAmount;
      if (detail.totalAmount != null && detail.totalAmount !== '') return detail.totalAmount;
      var wx = Number(detail.wxPayAmount) || 0;
      var integral = Number(detail.integralAmount) || 0;
      if (wx || integral) return wx + integral;
      return this.orderRow && this.orderRow.totalAmount != null ? this.orderRow.totalAmount : 0;
    },
    normalizeItem: function normalizeItem(item) {
      var quantity = Number(item.quantity) || 0;
      var unitPrice = Number(item.unitPrice != null ? item.unitPrice : item.otPrice) || 0;
      var subtotal = Number(item.totalPrice != null ? item.totalPrice : unitPrice * quantity) || 0;
      var discountAmount = Number(item.discountAmount != null ? item.discountAmount : item.couponPrice != null ? item.couponPrice : 0) || 0;
      var maxRefundAmount = Number(Math.max(0, subtotal - discountAmount).toFixed(2));
      return {
        id: item.id,
        skuId: item.skuId,
        productId: item.productId || item.spuId || item.skuId || '',
        productName: item.productName || item.skuName || '',
        spec: item.skuName || item.salesAttribute || item.spec || '-',
        image: item.imageUrl || item.image || '',
        code: item.skuCode || item.spuCode || item.skuId || '-',
        barcode: item.barcode || '-',
        quantity: quantity,
        unitPrice: unitPrice,
        subtotal: subtotal,
        discountAmount: discountAmount,
        maxRefundAmount: maxRefundAmount,
        checked: false,
        refundQuantity: quantity,
        refundAmount: maxRefundAmount
      };
    },
    handleCheckChange: function handleCheckChange(row) {
      if (row.checked) {
        row.refundQuantity = row.quantity;
        row.refundAmount = row.maxRefundAmount;
      }
    },
    handleQuantityBlur: function handleQuantityBlur(row) {
      if (row.refundQuantity === '' || row.refundQuantity == null) return;
      var qty = Number(String(row.refundQuantity).replace(/[^\d-]/g, ''));
      if (!Number.isInteger(qty) || qty <= 0) {
        row.refundQuantity = row.quantity;
        this.$message.warning('退款数量须为大于0的整数');
        return;
      }
      if (qty > row.quantity) {
        row.refundQuantity = row.quantity;
        this.$message.warning("\u9000\u6B3E\u6570\u91CF\u4E0D\u80FD\u5927\u4E8E\u8D2D\u4E70\u6570\u91CF".concat(row.quantity));
        return;
      }
      row.refundQuantity = qty;
    },
    handleAmountBlur: function handleAmountBlur(row) {
      if (row.refundAmount === '' || row.refundAmount == null) return;
      var num = Number(row.refundAmount);
      if (Number.isNaN(num) || num <= 0) {
        row.refundAmount = this.formatAmount(row.maxRefundAmount);
        this.$message.warning('退款金额须大于0');
        return;
      }
      if (num > row.maxRefundAmount) {
        row.refundAmount = this.formatAmount(row.maxRefundAmount);
        this.$message.warning("\u9000\u6B3E\u91D1\u989D\u4E0D\u80FD\u5927\u4E8E\u652F\u4ED8\u91D1\u989D\xA5".concat(this.formatAmount(row.maxRefundAmount)));
        return;
      }
      row.refundAmount = num.toFixed(2);
    },
    getSelectedRefundTotal: function getSelectedRefundTotal() {
      return this.goodsList.reduce(function (sum, item) {
        if (!item.checked) return sum;
        var amount = Number(item.refundAmount);
        return sum + (Number.isNaN(amount) ? 0 : amount);
      }, 0);
    },
    validatePartial: function validatePartial() {
      var selected = this.goodsList.filter(function (item) {
        return item.checked;
      });
      if (!selected.length) {
        this.$message.warning('请选择需要退款的商品');
        return false;
      }
      var _iterator = _createForOfIteratorHelper(selected),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          var qty = Number(item.refundQuantity);
          if (!Number.isInteger(qty) || qty <= 0) {
            this.$message.warning("\u5546\u54C1\u300C".concat(item.productName, "\u300D\u9000\u6B3E\u6570\u91CF\u987B\u4E3A\u5927\u4E8E0\u7684\u6574\u6570"));
            return false;
          }
          if (qty > item.quantity) {
            this.$message.warning("\u5546\u54C1\u300C".concat(item.productName, "\u300D\u9000\u6B3E\u6570\u91CF\u4E0D\u80FD\u5927\u4E8E\u8D2D\u4E70\u6570\u91CF").concat(item.quantity));
            return false;
          }
          var amount = Number(item.refundAmount);
          if (Number.isNaN(amount) || amount <= 0) {
            this.$message.warning("\u5546\u54C1\u300C".concat(item.productName, "\u300D\u9000\u6B3E\u91D1\u989D\u987B\u5927\u4E8E0"));
            return false;
          }
          if (amount > item.maxRefundAmount) {
            this.$message.warning("\u5546\u54C1\u300C".concat(item.productName, "\u300D\u9000\u6B3E\u91D1\u989D\u4E0D\u80FD\u5927\u4E8E\u652F\u4ED8\u91D1\u989D\xA5").concat(this.formatAmount(item.maxRefundAmount)));
            return false;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var refundTotal = Number(this.getSelectedRefundTotal().toFixed(2));
      var payAmount = Number(Number(this.orderAmount).toFixed(2));
      if (refundTotal > payAmount) {
        this.$message.warning("\u9000\u6B3E\u91D1\u989D\u5408\u8BA1\u4E0D\u80FD\u5927\u4E8E\u8BA2\u5355\u652F\u4ED8\u91D1\u989D\xA5".concat(this.formatAmount(payAmount)));
        return false;
      }
      return true;
    },
    handleConfirm: function () {
      var _handleConfirm = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var payload, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (!(this.refundType === 2 && !this.validatePartial())) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              this.submitting = true;
              _context2.p = 2;
              payload = {
                orderNo: this.orderNo,
                refundType: this.refundType
              };
              if (this.refundType === 2) {
                payload.itemList = this.goodsList.filter(function (item) {
                  return item.checked;
                }).map(function (item) {
                  return {
                    id: item.id,
                    skuId: item.skuId,
                    productId: item.productId,
                    refundQuantity: Number(item.refundQuantity),
                    refundAmount: Number(item.refundAmount)
                  };
                });
              }
              _context2.n = 3;
              return (0, _rsManagement.doTakeoutRefund)(payload);
            case 3:
              this.$message.success('退款成功');
              this.visible = false;
              this.$emit('success');
              _context2.n = 5;
              break;
            case 4:
              _context2.p = 4;
              _t2 = _context2.v;
              console.error('退款失败：', _t2);
            case 5:
              _context2.p = 5;
              this.submitting = false;
              return _context2.f(5);
            case 6:
              return _context2.a(2);
          }
        }, _callee2, this, [[2, 4, 5, 6]]);
      }));
      function handleConfirm() {
        return _handleConfirm.apply(this, arguments);
      }
      return handleConfirm;
    }(),
    formatAmount: function formatAmount(val) {
      var num = Number(val);
      if (Number.isNaN(num)) return '0.00';
      return num.toFixed(2);
    },
    resetForm: function resetForm() {
      this.refundType = 1;
      this.goodsList = [];
      this.orderRow = null;
      this.orderNo = '';
      this.orderAmount = 0;
    }
  }
};